import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current'
import { createSelector } from 'reselect'
import { hasPremiumPlusUserUtil } from '@gymaholic/packages'

export const hasPremiumPlusUserSelect = createSelector(
  getCurrentTrainingUserSelect,
  (user) => hasPremiumPlusUserUtil(user)
)
